module.exports = __webpack_public_path__ + "img/T4-D-rc_36.171cda11.png";